module.exports = __webpack_public_path__ + "img/star.7219d8bf.svg";